export default {"src":"/_next/static/media/icon_navigation_left_small.38f40cb8.svg","height":12,"width":6,"blurWidth":0,"blurHeight":0};